import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DeadlinesIconRenderer = ({ type, color }) => {
  return (
    type && (
      <FontAwesomeIcon
        icon={["fas", `${type}`]}
        style={{ color: `${color}`, fontSize: "16px" }}
      />
    )
  );
};

export default DeadlinesIconRenderer;
